import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  title?: string;
  duration: number; // 0 = persist until dismissed
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toasts = signal<Toast[]>([]);

  private add(type: ToastType, message: string, title?: string, duration = 5000): void {
    const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    this.toasts.update(list => [...list, { id, type, message, title, duration }]);
    if (duration > 0) setTimeout(() => this.dismiss(id), duration);
  }

  success(message: string, title?: string, duration?: number): void {
    this.add('success', message, title, duration);
  }

  error(message: string, title?: string, duration?: number): void {
    this.add('error', message, title, duration ?? 7000);
  }

  warning(message: string, title?: string, duration?: number): void {
    this.add('warning', message, title, duration);
  }

  info(message: string, title?: string, duration?: number): void {
    this.add('info', message, title, duration);
  }

  dismiss(id: string): void {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  dismissAll(): void {
    this.toasts.set([]);
  }
}
